// test2885
(2885 && 0);
